import { Box, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ChangeEvent } from 'react';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import ChartHelpTooltip from '../common/ChartHelpTooltip.tsx';
import type { FieldComponentProps } from '../form-engine/types';

const UploadField = ({ field }: FieldComponentProps) => {
  const { getFormDataItem, handleChange } = useFormContext();
  const formData = useFormData();

  // Function to determine if the button should be disabled
  const isDisabled = () => {
    if (!Object.prototype.hasOwnProperty.call(field, 'disabled')) {
      return false;
    }

    const disabledValue = field.disabled!;

    // For yield_evaluation.source, we want to enable the button only if source === 'csv'
    if (disabledValue === 'yield_evaluation.source') {
      const source = getFormDataItem(formData, disabledValue);
      return source !== 'csv';
    }

    // Existing logic for other cases
    return !!getFormDataItem(formData, disabledValue);
  };

  return (
    <Box>
      <Button variant="contained" component="label" startIcon={<CloudUploadIcon />} disabled={isDisabled()}>
        {field.label}
        <input
          type="file"
          accept=".csv"
          id="csv-upload"
          style={{ display: 'none' }}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            handleChange(
              {
                target: {
                  name: field.target as string,
                  value: e.target.value,
                  type: e.target.type,
                  checked: e.target.checked,
                  files: e.target.files,
                },
              },
              field,
            );
            e.target.value = '';
          }}
        />
      </Button>
      {Object.prototype.hasOwnProperty.call(field, 'help') ? (
        <Box sx={{ display: 'inline-flex' }}>
          <ChartHelpTooltip chartType={field.help!} />
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default UploadField;
